import classcat from "classcat";
import React, { useCallback, useState } from "react";
import { Thumbs } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";

import { EnlargeRefType } from "@is/components/EnlargeModal/EnlargeModal";
import { Image } from "@is/components/Image";
import { MediaVariants } from "@is/constants";
import { THUMBNAIL_SIZE } from "@is/constants/media";
import { MediaType } from "@is/types";

import css from "./EnlargeCarousel.module.css";
import EnlargeImage from "./EnlargeImage";
import MediaZoomer from "./MediaZoomer";

type Props = {
  initialSlide: number;
  medias: MediaType[];
  onClose: () => void;
  startTransition: boolean;
  enlargeRef: React.MutableRefObject<EnlargeRefType>;
};

const EnlargeCarousel = ({
  initialSlide,
  medias,
  onClose,
  startTransition,
  enlargeRef,
}: Props) => {
  const [thumbsSwiper, setThumbsSwiper] = useState(null);
  const [activeIndex, setActiveIndex] = useState(0);

  const handleSlideChange = useCallback(
    (swiper) => setActiveIndex(swiper.realIndex),
    []
  );

  const handleSwiper = useCallback((swiper) => {
    setThumbsSwiper(swiper);
  }, []);

  return (
    <div>
      <Swiper
        modules={[Thumbs]}
        initialSlide={initialSlide}
        spaceBetween={50}
        slidesPerView={1}
        thumbs={{ swiper: thumbsSwiper }}
        loop
        className={classcat([
          css.mainSwiper,
          { [css.transition]: startTransition },
        ])}
        onSlideChange={handleSlideChange}
      >
        {!!medias.length &&
          medias.map((media, index) => (
            <SwiperSlide key={media.url}>
              <MediaZoomer
                onClose={onClose}
                activeIndex={activeIndex}
                isClosing={!startTransition}
                enlargeRef={index === activeIndex ? enlargeRef : null}
              >
                <EnlargeImage url={media.url} active={index === activeIndex} />
              </MediaZoomer>
            </SwiperSlide>
          ))}
      </Swiper>
      <Swiper
        slidesPerView="auto"
        spaceBetween={16}
        watchSlidesProgress={true}
        modules={[Thumbs]}
        className={classcat([
          css.thumbsSwiper,
          { [css.transition]: startTransition },
        ])}
        style={{ width: window.innerWidth }}
        onSwiper={handleSwiper}
      >
        {!!medias.length &&
          medias.map((media, index) => (
            <SwiperSlide
              key={`thumb-${media.url}`}
              style={{
                boxSizing: "border-box",
                ...THUMBNAIL_SIZE,
                marginLeft: index === 0 ? "var(--space-10)" : "0",
                animationDelay: `${index * 0.1}s`,
              }}
              className={classcat([css.animationFadeInFloatUp])}
            >
              <Image
                src={media?.url}
                mediavariant={MediaVariants.THUMBNAIL}
                placeholderMediaVariant={MediaVariants.THUMBNAIL}
                layout="contain"
                className={classcat([
                  css.thumbImage,
                  { [css.active]: activeIndex === index },
                ])}
              />
            </SwiperSlide>
          ))}
      </Swiper>
    </div>
  );
};

export default EnlargeCarousel;
